import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'pd.productAlternatives.title',
    defaultMessage: 'Ostatni nakupuji',
  },
  noAlternativesTitle: {
    id: 'pd.productAlternatives.noAlternativesTitle',
    defaultMessage: 'Alternativy sme nenašli',
  },
  noAlternativesSubtitle: {
    id: 'pd.productAlternatives.noAlternativesSubtitle',
    defaultMessage: 'Pro tento produkt teď nemáme žádná doporučení.',
  },
});
